const context = {
    DateRangeDefault: '3',
    DateRangeOptions: [
        {
            Text: 'Past 3 Months',
            Value: '3'
        },
        {
            Text: 'Past 6 Months',
            Value: '6'
        },
        {
            Text: 'Past Year',
            Value: '12'
        },
        {
            Text: 'Past 2 Years',
            Value: '24'
        }
    ],
    ItemsInOrder: 'Items in Order ({0})',
    OrderNumber: 'Order Number',
    OrderNumberPending: '-',
    OrderPlaced: 'Order Placed',
    OrderTotal: 'Order Total',
    StatusOptions: [
        {
            Class: 'bg-color-vca-egg',
            Text: 'Cancelled'
        },
        {
            Class: 'bg-color-vca-mauve',
            Text: 'Delivered'
        },
        {
            Class: 'bg-color-vca-sky',
            Text: 'In Progress'
        }
    ]
};

export {
    context
};
